import useSWR, { mutate } from 'swr';
import { getUserPsuedoId, subscribeAnalyticsConsent } from 'lib/firebase/ga_analytics';
import { AuthState } from 'hooks/useFirebaseAuth';
import { useEffect } from 'react';

export const USER_PSEUDO_ID_LOADER_KEY = 'user-pseudo-id';

interface UserPseudoIdLoaderProps {
  authState: AuthState;
  setIsValidating: (value: boolean) => void;
  setUserPseudoId: (value?: string | null) => void;
}

const UserPseudoIdLoader = ({
  authState,
  setIsValidating,
  setUserPseudoId
}: UserPseudoIdLoaderProps) => {
  const { data: userPseudoId, isValidating } = useSWR(
    authState !== AuthState.PENDING ? USER_PSEUDO_ID_LOADER_KEY : null,
    getUserPsuedoId,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );

  useEffect(() => {
    return subscribeAnalyticsConsent(consented => {
      if (consented) {
        mutate(USER_PSEUDO_ID_LOADER_KEY);
      }
    });
  }, []);

  useEffect(() => {
    setIsValidating(isValidating);
    setUserPseudoId(userPseudoId);
  }, [isValidating, setIsValidating, userPseudoId, setUserPseudoId]);

  return null;
};

export default UserPseudoIdLoader;
